import { Directive, OnDestroy, OnInit, Optional, Self, ElementRef, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

import { ProjectSection } from '../models/access.models';
import { AccessService } from '../services/access.service';

/**
 * Directive: PermSwitchDirective
 *
 * Автоматически блокирует (делает `disabled` у) элемент `<input[app-switch]>`
 * если текущий пользователь не имеет права `<section>:edit`.
 * Секция берётся из `data['section']` маршрута, аналогично другим Perm* директивам.
 */
@Directive({ selector: 'input[app-switch]' })
export class PermSwitchDirective implements OnInit, OnDestroy {
  private readonly _destroy$ = new Subject<void>();
  private _wasDisabled = false;

  constructor(
    private readonly _el: ElementRef<HTMLInputElement>,
    private readonly _renderer: Renderer2,
    private readonly _route: ActivatedRoute,
    private readonly _access: AccessService,
  ) {}

  ngOnInit(): void {
    const data = this._route.snapshot.data ?? {};
    const section = data['section'] as ProjectSection | undefined;
    if (!section || data['skipPermDisable']) {
      return;
    }

    this._access
      .can$(section, 'edit')
      .pipe(takeUntil(this._destroy$))
      .subscribe((canEdit) => {
        if (!canEdit) {
          this._renderer.setProperty(this._el.nativeElement, 'disabled', true);
          this._wasDisabled = true;
        } else if (this._wasDisabled) {
          this._renderer.setProperty(this._el.nativeElement, 'disabled', false);
          this._wasDisabled = false;
        }
      });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
